"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSurveyEnabled = void 0;
const insights_engine_models_1 = require("@forto-dev/insights-engine-models");
const useIsSurveyEnabled = (ruleID) => {
    return ruleID ? insights_engine_models_1.motIDs.includes(ruleID) : false;
};
exports.useIsSurveyEnabled = useIsSurveyEnabled;
//# sourceMappingURL=useIsSurveyEnabled.js.map